<template>
  <div>
    <v-title>
      Direct Debit
      <span v-show="isQantas">(Bank account only)</span>
      <span v-show="!isQantas">
        (if credit card is being used, Vonex will contact you for details)
      </span>
    </v-title>
    <v-card>
      <v-card-text>
        <v-container grid-list-md>
          <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
            <v-form v-model="valid">
              <v-layout wrap>
                <v-flex>
                  <v-radio-group
                    v-model="directDebitStatus"
                    class="mb-2"
                    hide-details
                    @change="changeHandler"
                  >
                    <v-radio
                      color="#2f5578"
                      :label="hasDirectDebitLabel"
                      :value="1"
                      :disabled="!directDebit.hasDirectDebit"
                    ></v-radio>
                    <v-radio
                      color="#2f5578"
                      label="Enter New Direct Debit Details"
                      :value="2"
                    ></v-radio>
                    <v-radio
                      color="#2f5578"
                      label="Pay by Credit Card"
                      :value="3"
                      :disabled="isGrenke || isFinance"
                    ></v-radio>
                    <v-radio
                      color="#2f5578"
                      label="No direct debit information provided"
                      :value="4"
                    ></v-radio>
                  </v-radio-group>
                  <span class="red--text text-caption ml-4">
                    *Only products that have no contracts, and are eligible for
                    prepayment will be available for order
                  </span>
                </v-flex>
              </v-layout>
              <v-layout v-if="directDebitStatus == 2" wrap>
                <v-flex sm6 md6 lg6>
                  <vonex-text
                    ref="financialInstitutionName"
                    v-model="directDebit.financialInstitutionName"
                    name="financialInstitutionName"
                    label="Financial Institution Name"
                    :rule="'required'"
                    :options="fieldConditions"
                    @keyup="setDirectDebit"
                  />
                  <!-- <v-text-field
                    label="Financial Institution Name"
                    name="Instituation Name"
                    v-validate="'required'"
                    v-model="directDebit.financialInstitutionName"
                    :error-messages="errors.collect('Instituation Name')"
                    @keyup="setDirectDebit"
                  ></v-text-field>-->
                </v-flex>
                <v-flex sm6 md6 lg6>
                  <vonex-text
                    ref="financialInstitutionBranch"
                    v-model="directDebit.financialInstitutionBranch"
                    name="financialInstitutionBranch"
                    label="Financial Institution Branch"
                    :rule="'required'"
                    :options="fieldConditions"
                    @keyup="setDirectDebit"
                  />
                  <!-- <v-text-field
                    label="Financial Institution Branch"
                    name="Instituation Branch"
                    v-validate="'required'"
                    v-model="directDebit.financialInstitutionBranch"
                    :error-messages="errors.collect('Instituation Branch')"
                    @keyup="setDirectDebit"
                  ></v-text-field>-->
                </v-flex>
                <v-flex sm6 md6 lg6>
                  <vonex-text
                    ref="accountName"
                    v-model="directDebit.accountName"
                    name="accountName"
                    label="Account Name"
                    :rule="'required'"
                    :options="fieldConditions"
                    @keyup="setDirectDebit"
                  />
                  <!-- <v-text-field
                    label="Account Name"
                    name="Account Name"
                    v-validate="'required'"
                    v-model="directDebit.accountName"
                    :error-messages="errors.collect('Account Name')"
                    @keyup="setDirectDebit"
                  ></v-text-field>-->
                </v-flex>
                <v-flex sm3 md3 lg3>
                  <vonex-text
                    ref="BSB"
                    v-model="directDebit.bsb"
                    name="BSB"
                    mask="###-###"
                    return-masked-value
                    :rule="'required|bsbNumber'"
                    label="BSB"
                    :options="fieldConditions"
                    @keyup="setDirectDebit"
                  />
                  <!-- <v-text-field
                    label="BSB"
                    name="BSB"
                    v-validate="'required|bsbNumber'"
                    mask="###-###"
                    v-model="directDebit.bsb"
                    return-masked-value
                    :error-messages="errors.collect('BSB')"
                    @keyup="setDirectDebit"
                  ></v-text-field>-->
                </v-flex>
                <v-flex sm3 md3 lg3>
                  <vonex-text
                    ref="accountNumber"
                    v-model="directDebit.accountNumber"
                    type="number"
                    name="Account Number"
                    :rule="'required|min:6|maxNumber:10|bankAccountNumber'"
                    label="Account Number"
                    :options="fieldConditions"
                    @keyup="setDirectDebit"
                  />
                  <!-- <v-text-field
                    type="number"
                    label="Account Number"
                    name="Account Number"
                    v-validate="'required|min:6|max:10|bankAccountNumber'"
                    v-model="directDebit.accountNumber"
                    return-masked-value
                    :error-messages="errors.collect('Account Number')"
                    @keyup="setDirectDebit"
                  ></v-text-field>-->
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex sm12 lg12 right>
                  <v-btn
                    v-show="!$store.getters['orders/changeLessee/createOnly']"
                    color="primary"
                    @click="save"
                  >
                    Save & Next
                  </v-btn>
                </v-flex>
                <v-flex>
                  <message-alert :component="message"></message-alert>
                </v-flex>
              </v-layout>
            </v-form>
          </ValidationObserver>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { createNamespacedHelpers, mapGetters } from 'vuex';
import { mapOrderFields } from '../store/modules/orders';
import { DirectDebit } from '../models/DirectDebit';
import Utils from '@/mixins/utils.mixin';
const { mapActions: mapOrderActions } = createNamespacedHelpers(`orders`);
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
const { mapMutations: mapCustomerMutations } =
  createNamespacedHelpers(`orders/customer`);
const { mapActions: mapCustomerActions } =
  createNamespacedHelpers(`orders/customer`);

export default {
  name: 'DirectDebit',
  mixins: [Utils],
  data() {
    return {
      valid: false,
      directDebit: new DirectDebit(),
      directDebitStatus: null,
      hasDirectDebitLabel: '',
    };
  },
  computed: {
    ...mapOrderFields(['message']),
    ...mapOrderState(['customer', 'rows']),
    ...mapGetters('orders', [
      'isQantas',
      'hasExistingDD',
      'ddOption',
      'isGrenke',
      'isFinance',
      'isResidential',
    ]),
  },
  methods: {
    ...mapOrderActions(['updateDirectDebit', 'getDirectDebit']),
    ...mapCustomerMutations(['setCustomerDirectDebit']),
    ...mapCustomerActions(['updateCustomer']),
    save() {
      let vm = this;
      vm.$refs.observer.validate().then(async (result) => {
        if (result) {
          vm.updateDirectDebit(vm.directDebit).then(() => {
            vm.initDirectDebit();
            if (!vm.directDebit.hasDirectDebit) {
              vm.setCustomerDirectDebit('Yes');
              vm.updateCustomer(vm.customer.customer.customerID);
            }
            vm.$router.push(
              `${vm.isResidential ? '/create-sip' : '/create-ipvoice'}`
            );
          });
        }
      });
    },
    setDirectDebit() {
      this.$emit(`setDirectDebit`, this.directDebit);
    },
    changeHandler(e) {
      let vm = this;
      vm.directDebit.option = e;
      switch (e) {
        case 1:
          vm.directDebit.useExisting = true;
          vm.directDebit.payWithCreditCard = false;
          vm.directDebit.noDetailsProvided = false;
          break;
        case 2:
          vm.directDebit.payWithCreditCard = false;
          vm.directDebit.useExisting = false;
          vm.directDebit.noDetailsProvided = false;
          break;
        case 3:
          vm.directDebit.useExisting = false;
          vm.directDebit.payWithCreditCard = true;
          vm.directDebit.noDetailsProvided = false;

          break;
        case 4:
          vm.directDebit.useExisting = false;
          vm.directDebit.payWithCreditCard = false;
          vm.directDebit.noDetailsProvided = true;
          break;
        default:
          break;
      }
      vm.setDirectDebit();
    },
    initDirectDebit() {
      let vm = this;
      vm.getDirectDebit().then((data) => {
        vm.directDebit = { ...vm.directDebit, ...vm.rows[0].directDebit };
        vm.directDebitStatus = vm.rows[0].directDebit.option;
        vm.changeHandler(vm.directDebitStatus);
        let label = 'Use Customers Existing Direct Debit Details';
        if (vm.directDebit.hasDirectDebit) vm.hasDirectDebitLabel = label;
        else
          vm.hasDirectDebitLabel =
            label +
            ' - Disabled: Customer does not have Direct Debit details recorded';
      });
    },
  },
  mounted() {
    let vm = this;
    vm.initDirectDebit();
  },
  watch: {
    rows: {
      handler: function (prev, next) {
        let vm = this;
        vm.initDirectDebit();
        vm.$eventBus.$emit('showValidation', false);
      },
      deep: true,
    },
  },
};
</script>
